// extracted by mini-css-extract-plugin
export default {"container":"AllButton_container__SbamR","wrapper":"AllButton_wrapper__SIevC","text":"AllButton_text__DhIxw"};